import { render } from "./IconPdf.vue?vue&type=template&id=9ca7f540"
import script from "./IconPdf.vue?vue&type=script&lang=js"
export * from "./IconPdf.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__